import React from "react";
import { ThemeProvider, Theme, StyledEngineProvider } from "@mui/material";
import {AppWithAuth} from "./app";
import {store} from "./redux/store";
import {Provider} from "react-redux";
import './localization';
import {
  TaskQueueProvider,
  ViewerProvider,
  ActiveToolProvider,
  AuthProvider,
  BookmarksProvider,
  GlobalSettingsProvider,
  WebSocketProvider,
  BrandingProvider
} from "./providers";
import { useBranding } from "./hooks/use-branding";

declare module '@mui/styles/defaultTheme' {
  // eslint-disable-next-line @typescript-eslint/no-empty-interface
  interface DefaultTheme extends Theme {}
}

const ThemedViewer = () => {
  return (
    <BrandingProvider>
      <EngineViewer/>
    </BrandingProvider>
  );
};

const EngineViewer = () => {
  const branding = useBranding();
  const theme = branding.theme;

  return (
    <Provider store={store}>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={theme}>
          <WebSocketProvider>
            <AuthProvider>
              <ViewerProvider>
                <BookmarksProvider>
                  <GlobalSettingsProvider>
                    <TaskQueueProvider>
                      <ActiveToolProvider>
                        <AppWithAuth/>
                      </ActiveToolProvider>
                    </TaskQueueProvider>
                  </GlobalSettingsProvider>
                </BookmarksProvider>
              </ViewerProvider>
            </AuthProvider>
          </WebSocketProvider>
        </ThemeProvider>
      </StyledEngineProvider>
    </Provider>
  );
};

export default ThemedViewer;